/**
 * similar-patients module
 */
import {NgModule} from '@angular/core';
import {CoreModule} from '@ispm/core/core.module';
import {SharedModule} from '@ispm/shared/shared.module';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {LayoutEngineModule} from '@ispm-client/modules/layout-engine/layout-engine.module';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';
import {LayoutModule} from '@ispm/layout/layout.module';
import {SelectionItemModule} from '@ispm-client/modules/selection-item/selection-item.module';
import {SimilarPatientsAnalyticsComponent} from "@ispm-client/modules/similar-patients/components/similar-patients-analytics.component";
import {TestModule} from '@ispm/test/test.module';
import {SimilarPatientsAnalyticsViewComponent} from "@ispm-client/modules/similar-patients/view/similar-patients-analytics-view.component";
import {UserModule} from "@ispm/user/user.module";
import {UserService} from "@ispm/user/services/user.service";
import {patientResolver} from "@ispm-client/modules/similar-patients/similar-patients-exports";
import {StoreModule} from '@ngrx/store';
import {SimilarPatientsEffects, similarPatientsReducer} from '@ispm-client/modules/similar-patients/store';
import {metaReducers} from '@ispm-client/modules/similar-patients/store/reducer/reducer';
import {EffectsModule} from '@ngrx/effects';
import {SimilarPatientService} from '@ispm-client/modules/similar-patients/services/similar-patient.service';
import {FilterModule} from "../../app/filter/filter.module";
import {RouterModule} from "@angular/router";


@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    DynamicFormModule,
    LayoutEngineModule,
    WidgetsModule,
    AggregatorModule,
    LayoutModule,
    SelectionItemModule,
    TestModule,
    UserModule,
    FilterModule,
    StoreModule.forFeature('similarPatientsData', similarPatientsReducer, { metaReducers}),
    EffectsModule.forFeature([SimilarPatientsEffects]),
    RouterModule.forRoot([])
  ],
  declarations: [SimilarPatientsAnalyticsComponent, SimilarPatientsAnalyticsViewComponent],
  providers: [SimilarPatientService],
  exports: [SimilarPatientsAnalyticsComponent]
})
export class SimilarPatientsModule {
}
